export const GET_NEWS = "GET_NEWS";
export const SEARCH_NEWS = "SEARCH_NEWS";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_INPUT = "CHANGE_INPUT";
export const CHANGE_SORT = "CHANGE_SORT";
export const LOAD = "LOAD";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
